"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("./styles");
var _Text = _interopRequireDefault(require("../../Text"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const TabItem = ({
  text,
  icon,
  active,
  onClick
}) => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.TabWrapper, {
    onClick: onClick,
    "aria-label": `Tab knapp for ${text}`,
    children: [icon, /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
      primary: active,
      secondary: !active,
      size: "10px",
      children: text
    })]
  });
};
var _default = exports.default = TabItem;